<template>
  <div class="row justify-content-center uk-">
    <div class="col-md-12">

      <div class="row">

        <div class="col-md-12 card">
              <div class="uk-padding">
                <div class="card-header card-header-primary">
                  <h3 class="card-title">Modification des informations</h3>
                </div>
                <div class="card-body">

                  <form @submit.prevent="onUpdateForm">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="bmd-label-floating" style="color:#34b76e;; font-size:1.2em; text-transform:capitalize">
                            Nom de l'utilisateur
                          </label>
                          <input v-model="user.name" type="text" class="form-control" required style="border-radius: 10px 10px 10px 10px;">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="bmd-label-floating" style="color:#34b76e;; font-size:1.2em; text-transform:capitalize">
                            Conatct de l'utilisateur
                          </label>
                          <input v-model="user.number" type="text" class="form-control" required style="border-radius: 10px 10px 10px 10px;">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="bmd-label-floating" style="color:#34b76e;; font-size:1.2em; text-transform:capitalize">
                            Role de l'utilisateur
                          </label>
                          <select class="form-control" v-model="user.role" required style="border-radius: 10px 10px 10px 10px;">
                            <option value="0">Client</option>
                            <option value="1">Livreur</option>
                            <option value="2">Commerciaux</option>
                            <option value="3">Superviseur</option>
                            <option value="4">Logisticien</option>
                            <option value="5">Administrateur</option>
                            <option value="6">Boutique</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="bmd-label-floating" style="color:#34b76e;; font-size:1.2em; text-transform:capitalize">
                            Adresse email de l'utilisateur
                          </label>
                          <input v-model="user.email" type="text" class="form-control">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="bmd-label-floating" style="color:#34b76e;; font-size:1.2em; text-transform:capitalize">
                            Activé la promotion
                          </label>
                          <select class="form-control" v-model="user.reductionActif" id="" style="border-radius: 10px 10px 10px 10px;">
                            <option value="0">Non</option>
                            <option value="1">Oui</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div>
                        <b-alert v-if="user.reductionActif == '0'" variant="danger" show>
                          <p style="font-size: 1.3em"> 
                            Il n'y a de réduction pour ce client!!!
                          </p>
                        </b-alert>
                        <b-alert v-if="user.reductionActif == '1'" variant="default" show style="background-color: #34b76e;">
                          <p style="font-size: 1.3em"> 
                            Il y a un réduction pour ce client!!!
                          </p>
                        </b-alert>
                    </div>
                    <button class="btn btn-success pull-right" style="background-color: #34b76e; color: white; border-radius: 10px 10px 10px 10px;">
                      Mettre à jour
                    </button>
                    <div class="clearfix"></div>
                  </form>
                </div>
              </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { db } from "../../main";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      user: {},
    };
  },

  created() {
    let dbRef = db.ref("users").child(this.$route.params.id);
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.user = childData;
      })
      .catch((error) => {
        console.log(dbRef);
      });
  },

  methods: {
    onUpdateForm(event) {
      let go = this
      event.preventDefault();
      db.ref("users")
        .child(this.$route.params.id)
        .set(this.user)
        .then(() => {
        console.log("Mise à jour effectuée");
        go.$router.push({path:'/admin/clients'});
            Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Mise à jour éffectuée',
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.uk-padding {
  margin-top: 100px;
  margin-left: 250px;
  margin-right: 250px;
}
</style>